import { ReactNode, useEffect, useRef, useState } from "react"
import { useMyColaborador } from "src/shared/providers/ColaboradorProvider"
import ColabInactiveModal from "../components/modal/ColabInactiveModal/ColabInactiveModal"
import { RoleNames } from "./useAuth"
import { useProfile } from "./useProfile"

const useIsColaboradorActive = () => {
    const colab = useMyColaborador()
    const { rolName } = useProfile()

    // los callers (ej. GastosList) suelen "hornear" la función devuelta por
    // validateIsColabActive dentro de estado calculado en un useEffect con
    // dependencias incompletas, por lo que puede invocarse mucho después de
    // creada. Un ref garantiza que siempre lea el estado más reciente al
    // momento del click, sin importar cuándo se creó el closure.
    const colabRef = useRef(colab)
    const rolNameRef = useRef(rolName)
    useEffect(() => {
        colabRef.current = colab
        rolNameRef.current = rolName
    }, [colab, rolName])

    const [isShowingUnauthorizedModal, setshowUnauthorizedModal] = useState(false)

    const validateIsColabActive = <T = unknown, N = void>(cb: (...args: T[]) => N): ((...args: T[]) => void) => {
        return (...args: T[]) => {
            const isActive =
                colabRef.current?.en_turno ||
                [RoleNames.admin, RoleNames.superadmin].includes(rolNameRef.current as RoleNames)
            if (isActive) {
                cb(...args)
                return
            }
            setshowUnauthorizedModal(true)
        }
    }

    const InactiveModal: ReactNode = isShowingUnauthorizedModal ? (
        <ColabInactiveModal isOpen onClose={() => setshowUnauthorizedModal(false)} />
    ) : null

    return { validateIsColabActive, InactiveModal }
}

export default useIsColaboradorActive
